import type { RouteLocationRaw } from 'vue-router';

/**
 * Guard for the subscription pages that only make sense when the company may pay by card.
 * Without the permission the whole card flow is hidden, so a direct URL hit lands on the
 * subscription overview instead of an empty page.
 */
export const requireCardPayment = (
  isEnabled: () => boolean
): true | RouteLocationRaw => {
  return isEnabled() ? true : { name: 'subscription-overview' };
};
